export function getCookie(key: string) {
  return document.cookie?.split(`${key}=`)[1]?.split(';')[0];
}
